import { Typography } from '@execonline-inc/execonline-ui';
import { T } from '../../../../../../../../Translations';
import SpinnerIcon from '../../../../../../../Cutesies/SpinnerIcon';

export default function RefreshingSpinner() {
  return (
    <div role="status" className="flex flex-col items-center">
      <SpinnerIcon />
      <Typography fontWeight="semibold" variant="h6" className="mt-6">
        <T kind="Refreshing Collection Preview" />
      </Typography>
      <Typography variant="bodyMedium" className="text-[#676767]">
        <T kind="Please wait while we load the changes" />
      </Typography>
    </div>
  );
}
